/* global G */
// see GAIA-514, GAIA-407
import { curry, setKey } from '@gaia/util'
import settings from '@tenant/settings'

/**
 * Attempts to end the current user's session by performing a logout request to the server.
 *
 * If the current user is external (OAuth), the logout request should return the data needed by the
 * client in order to redirect the user to the authentication page and end their session there. This
 * function saves said data as an `oauth` property in the current model's state.
 *
 * @param {Gaia.AppModule.Spec} module  the application's current module
 * @returns {Promise<*>}
 */
const sequenceSessionCookieLogout = async (module) => {
  let result

  try {
    result = await module[G.MODEL][G.ADAPTER][G.HTTP].post({ url: '/api/v1/logout' }, {
      middleware: ({ error, loader, invite, ...rest }) => Object.values(rest),
    })
  } catch (e) {
    console.error('Error during logout call:', e)
  }

  settings?.oauth?.enabled
    && result?.oidc_payload
    && setKey(result, 'oauth', module[G.MODEL][G.STATE])

  const sessionState = module[G.ADAPTER][G.SESSION][G.STATE]
  sessionState[G.META] = null
}

export default curry(sequenceSessionCookieLogout)
